import { Controller } from 'react-hook-form';
import { Checkbox as MUICheckbox } from '@mui/material';
import { FormControlLabel } from '@customink/pigment-react';
import { AddressDialogFieldProps } from '../../types';

export const IsDefault = ({ control }: AddressDialogFieldProps) => (
    <Controller
        name="isDefault"
        control={control}
        render={({ field: { value, ...field } }) => (
            <FormControlLabel
                // eslint-disable-next-line react/jsx-props-no-spreading
                control={<MUICheckbox checked={value} {...field} />}
                label="Make this your default address"
            />
        )}
    />
);
